import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StudentPaymentTempDetail, StudentPaymentTempDetailList } from '../student-payment/student-payment.model';
import { PayPalComplete } from '../student-payment/payment-online/paypal-payment/paypal.model';
import { logRequest } from 'app/main/shared/http-utils';

@Injectable({
    providedIn: 'root',
})
export class StudentPaymentDetailService {
    baseUrl = '/school-service/api/student-payment-details';

    constructor(private http: HttpClient) {
        console.log('Student Payment service created');
    }

    getById(detailId: string): Observable<HttpResponse<StudentPaymentTempDetail>> {
        return this.http.get<StudentPaymentTempDetail>(`${this.baseUrl}/${detailId}`, {
            observe: 'response',
        });
    }
    getByPaymentId(paymentId: string): Observable<HttpResponse<StudentPaymentTempDetailList[]>> {
        return this.http.get<StudentPaymentTempDetailList[]>(`${this.baseUrl}/payment/${paymentId}`, {
            observe: 'response',
        });
    }
    getByFeeId(feeId: string): Observable<HttpResponse<StudentPaymentTempDetail>> {
        return this.http.get<StudentPaymentTempDetail>(`${this.baseUrl}/fee/${feeId}`, {
            observe: 'response',
        });
    }

    update(paymentDetail: StudentPaymentTempDetail): Observable<HttpResponse<StudentPaymentTempDetail>> {
        return this.http.put<StudentPaymentTempDetail>(this.baseUrl, paymentDetail, { observe: 'response' });
    }

    create(paymentDetail: StudentPaymentTempDetail): Observable<HttpResponse<StudentPaymentTempDetail>> {
        return this.http.post<StudentPaymentTempDetail>(this.baseUrl, paymentDetail, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    deleteById(detailId: string): any {
        return this.http.delete(`${this.baseUrl}/${detailId}`, { observe: 'response', headers: logRequest() });
    }

    map(response: StudentPaymentTempDetail): StudentPaymentTempDetail {
        const result: StudentPaymentTempDetail = Object.assign({}, response);
        console.log('Map Result:', result);
        return result;
    }

    completePayPal(payPalComplete: PayPalComplete): any {
        return this.http.post<PayPalComplete>(`${this.baseUrl}/paypal-complete`, payPalComplete, {
            observe: 'response',
            headers: logRequest(),
        });
    }
}
